import * as yup from 'yup'
import { removeAllNonDigitChar } from 'baby-ui/utils'
import {
  DUE_DATE_MONTH_RANGE,
  MAXIMUM_PATIENT_AGE,
  MINIMUM_PATIENT_AGE,
} from 'shared/constants'
import { isBirthdayWithinRange, isDueDateWithinRange } from './helper'

const yearRegex = /^\d{4}$/
const monthRegex = /^(0[1-9]|1[0-2])$/
const dayRegex = /^(0[1-9]|[12][0-9]|3[01])$/
const maskedPhoneNumberRegex = /^\([1-9]\d{2}\) \d{3}-\d{4}$/

const date = yup
  .string()
  .test({
    name: 'is-date-empty',
    test(value, ctx) {
      if (!removeAllNonDigitChar(value || '')) {
        return ctx.createError({ message: 'Date of birth is required' })
      }

      return true
    },
  })
  .test({
    name: 'is-month-valid',
    test(value, ctx) {
      const month = value?.split('-')[1] || ''

      if (!monthRegex.test(month)) {
        return ctx.createError({
          message: 'Month must be between 01-12',
        })
      }

      return true
    },
  })
  .test({
    name: 'is-day-valid',
    test(value, ctx) {
      const day = value?.split('-')[2] || ''

      if (!dayRegex.test(day)) {
        return ctx.createError({
          message: 'Day must be between 01-31',
        })
      }

      return true
    },
  })
  .test({
    name: 'is-year-valid',
    test(value, ctx) {
      const year = value?.split('-')[0] || ''

      if (!yearRegex.test(year)) {
        return ctx.createError({
          message: 'Year is invalid',
        })
      }

      return true
    },
  })

export const CustomerInformationSchema = yup.object().shape({
  email: yup.string().email('Enter a valid email address.'),
  phoneNumber: yup
    .string()
    .matches(maskedPhoneNumberRegex, 'Enter a valid phone number.'),
  birthDate: date.test({
    name: 'is-birth-date-in-range',
    test(value, ctx) {
      if (!isBirthdayWithinRange(value || '')) {
        return ctx.createError({
          message: `Must be between ${MINIMUM_PATIENT_AGE} and ${MAXIMUM_PATIENT_AGE} years ago`,
        })
      }

      return true
    },
  }),
  dueDate: date.test({
    name: 'is-due-date-in-range',
    test(value, ctx) {
      if (!isDueDateWithinRange(value || '')) {
        return ctx.createError({
          message: `Must be within ${DUE_DATE_MONTH_RANGE} months from now`,
        })
      }

      return true
    },
  }),
})
